import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=306d5de8&"
import script from "./policy.vue?vue&type=script&setup=true&lang=js&"
export * from "./policy.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports